const VehicleSpec = () => {
  const components = document.querySelectorAll('.js-vehicleSpec');

  for (const component of components) {
    const trigger = component.querySelector('.js-vehicleSpec-title');

    if (!trigger) {
      continue;
    }

    const handler = () => {
      component.classList.toggle('-open');
    };

    trigger.addEventListener('click', handler);
  }
};

export default VehicleSpec;
